export default __webpack_public_path__ + "static/title-time-b9b86f3b766fe988a7cbbe630a59548a.png";